function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { EmptyWarningMessage, InvalidEmailMessage, SubmitErrorMessage } from "./consts";
import { checkIsValidEmail } from "./helpers";
import { Container, EmailInput, Form, IconContainer, InputContainer, StyledIconArrowPrevious, StyledSignupButton, WarningMessage } from "./styles";
export const EmailForm = ({
  onPreviousClick,
  onSubmit,
  ...props
}) => {
  const [emailInput, setEmailInput] = useState("");
  const [warningMessage, setWarningMessage] = useState(EmptyWarningMessage);
  const [isLoading, setIsLoading] = useState(false);
  const {
    executeRecaptcha
  } = useGoogleReCaptcha();
  const handleOnSubmit = async () => {
    if (!checkIsValidEmail(emailInput)) {
      setWarningMessage(InvalidEmailMessage);
      return;
    }
    setIsLoading(true);
    const recaptchaToken = await (executeRecaptcha === null || executeRecaptcha === void 0 ? void 0 : executeRecaptcha());
    if (!recaptchaToken) return;
    setWarningMessage(EmptyWarningMessage);
    const apiResponse = await onSubmit({
      email: emailInput,
      recaptchaToken
    });
    if (apiResponse !== null && apiResponse !== void 0 && apiResponse.error) {
      setWarningMessage(SubmitErrorMessage);
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "email-form"
  }), /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(StyledIconArrowPrevious, {
    height: "15",
    width: "15",
    onClick: onPreviousClick
  })), /*#__PURE__*/React.createElement(Form, {
    method: "post",
    onSubmit: event => {
      event.preventDefault();
      void handleOnSubmit();
    }
  }, /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(EmailInput, {
    $isError: !!warningMessage,
    placeholder: "Email",
    value: emailInput,
    onChange: event => {
      if (!event.target.value) {
        setWarningMessage(EmptyWarningMessage);
      }
      setEmailInput(event.target.value);
    }
  }), warningMessage && /*#__PURE__*/React.createElement(WarningMessage, null, warningMessage)), /*#__PURE__*/React.createElement(StyledSignupButton, {
    isLoading: isLoading,
    onClick: event => {
      event.preventDefault();
      void handleOnSubmit();
    }
  }, "SIGN UP")));
};
EmailForm.displayName = "EmailForm";